import React from "react";
import About from "./About";
import Header from "./Header";
import Home from "./Home";
import Team from "./Team";

export const Main = ({ data, language }) => {
  return (
    <div style={{ overflowX: "hidden" }}>
      <Header
        title={language ? data.English.Title : data.Mongolian.Title}
        data={language ? {... data.English.Header, ... data.English.Contact} :{... data.Mongolian.Header, ... data.Mongolian.Contact}}
      />
      <Home data={language ? data.English.Home : data.Mongolian.Home} benefitData={language ? data.English.Benefit : data.Mongolian.Benefit} language={language} />
      <About data={language ? data.English.About : data.Mongolian.About} />
      <Team data={language ? data.English.Team : data.Mongolian.Team} language={language} />
    </div>
  );
};
